import { useState } from "react";
import JSZip from "jszip";
import { FileArchive, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { buildReportPdf, downloadBlob, reportFileName } from "@/lib/pdf";

const today = () => new Date().toISOString().slice(0, 10);
const monthStart = () => today().slice(0, 8) + "01";

export function ReportsZipButton() {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(today());
  const [prog, setProg] = useState(null);
  const run = async () => {
    setProg("Ricerca interventi…");
    try {
      const { data } = await api.get("/admin/jobs", { params: { status: "completato", date_from: from, date_to: to } });
      if (!data.length) { toast.info("Nessun intervento completato nel periodo scelto"); return; }
      const zip = new JSZip();
      const used = {};
      for (let i = 0; i < data.length; i++) {
        setProg(`Rapporto ${i + 1} di ${data.length}…`);
        const base = reportFileName(data[i]).replace(/\.pdf$/, "");
        used[base] = (used[base] || 0) + 1;
        zip.file(`${base}${used[base] > 1 ? `-${used[base]}` : ""}.pdf`, await buildReportPdf(data[i]));
      }
      setProg("Creazione ZIP…");
      downloadBlob(await zip.generateAsync({ type: "blob" }), `MDN-Rapporti-${from}_${to}.zip`);
      toast.success(`${data.length} rapporti scaricati`);
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setProg(null);
    }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="rounded-full" onClick={() => setOpen(true)} data-testid="reports-zip-open"><FileArchive className="h-4 w-4" /> Rapporti PDF (ZIP)</Button>
      <Dialog open={open} onOpenChange={(o) => !prog && setOpen(o)}>
        <DialogContent className="sm:max-w-sm" data-testid="reports-zip-dialog">
          <DialogHeader><DialogTitle>Scarica rapporti del periodo</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">Tutti i rapporti PDF degli interventi completati nel periodo, in un unico file ZIP.</p>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="text-xs">Dal</Label><Input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} data-testid="reports-zip-from" /></div>
            <div className="space-y-1.5"><Label className="text-xs">Al</Label><Input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} data-testid="reports-zip-to" /></div>
          </div>
          {prog && <p className="text-sm text-[#3d6b16]" data-testid="reports-zip-progress">{prog}</p>}
          <DialogFooter>
            <Button className="rounded-full" onClick={run} disabled={!!prog || !from || !to} data-testid="reports-zip-download">
              {prog ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileArchive className="h-4 w-4" />} Scarica ZIP</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
